// extracted by mini-css-extract-plugin
module.exports = {"root":"Users_root__3MPTB","buttons":"Users_buttons__3l-E9","fullSize":"Users_fullSize__2_9lL"};